import React from "react";

import { Text } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

const current_year = new Date().getFullYear();

export const AllRightsReserved = ({
  company_name
}: {
  company_name: string;
}) => {
  const { translator } = useAppContext();
  const all_rights_reserved = `© ${current_year} ${company_name}, ${translator.t(
    "!footer.all-rights-reserved"
  )}`;

  return (
    <Text
      as="p"
      size="sm"
      className="truncate font-weight-bold text-color-tertiary"
    >
      {all_rights_reserved}
    </Text>
  );
};
